<template lang="html">
  <div>

    <!-- Botão para imprimir a tela (relatório técnico em PDF) -->
    <v-layout style="position: absolute; z-index: 1; left: 40px; top: 40px">
      <v-btn class="btnGerarPDF" color="primary" onclick="window.print()">Gerar PDF</v-btn>
    </v-layout>

    <v-card class="text-xs-center" style="margin: 0px 30px 20px;">

      <br><br>

      <v-layout justify-center>

        <!-- Título da tela -->
        <h2>Relatório Técnico de Extensão {{ this.relatorioExtensao.ordem }} - {{ this.projeto.titulo }}</h2>

      </v-layout>

      <br>

      <basic-toolbar style="text-align: center; height: 12.5px; padding-top: 7px;"></basic-toolbar>

      <v-card-text>

        <br>

        <!-- Título -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.tituloAcaoExtensao !== null"
              label="Título" :value="this.relatorioExtensao.tituloAcaoExtensao"></c-readonly-field>
            <c-readonly-field class="textoRelatorio" v-else label="Título" value="-"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Nome do coordenador -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.nomeCoordenador !== null"
              label="Nome do coordenador" :value="this.relatorioExtensao.nomeCoordenador"></c-readonly-field>
            <c-readonly-field class="textoRelatorio" v-else label="Nome do coordenador" value="-"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Número e Tipo -->
        <v-layout row>
          <!-- Número -->
          <v-flex md6 xs12>
            <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.numeroAcaoExtensao !== null"
              label="Número" :value="this.relatorioExtensao.numeroAcaoExtensao"></c-readonly-field>
            <c-readonly-field class="textoRelatorio" v-else label="Número" value="-"></c-readonly-field>
          </v-flex>
          <!-- Tipo -->
          <v-flex md6 xs12>
            <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.tipoAcaoExtensao !== null" label="Tipo"
              :value="this.relatorioExtensao.tipoAcaoExtensao"></c-readonly-field>
            <c-readonly-field class="textoRelatorio" v-else label="Tipo" value="-"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Unidade -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.unidade !== null" label="Unidade"
              :value="this.relatorioExtensao.unidade"></c-readonly-field>
            <c-readonly-field class="textoRelatorio" v-else label="Unidade" value="-"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- E-mail do coordenador -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.emailCoordenador !== null"
              label="E-mail do coordenador" :value="this.relatorioExtensao.emailCoordenador"></c-readonly-field>
            <c-readonly-field class="textoRelatorio" v-else label="E-mail do coordenador" value="-"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Liberação de carga horária do coordenador e Carga horária -->
        <v-layout row>
          <!-- Liberação de carga horária do coordenador -->
          <v-flex md6 xs12>
            <c-readonly-field class="textoRelatorio"
              v-if="this.relatorioExtensao.liberacaoCargaHorariaCoordenador !== null"
              label="Liberação de carga horária do coordenador"
              :value="this.relatorioExtensao.liberacaoCargaHorariaCoordenador == true ? 'Sim' : 'Não'"></c-readonly-field>
            <c-readonly-field class="textoRelatorio" v-else label="Liberação de carga horária do coordenador"
              value="-"></c-readonly-field>
          </v-flex>
          <!-- Carga horária -->
          <v-flex md6 xs12>
            <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.cargaHorariaCoordenador !== null"
              label="Carga horária" :value="this.relatorioExtensao.cargaHorariaCoordenador"></c-readonly-field>
            <c-readonly-field class="textoRelatorio" v-else label="Carga horária" value="-"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Relatório Técnico Final de cursos/oficinas (39729), cursos (44194), oficinas (44195) e eventos (39730) -->
        <v-layout row
          v-if="(projeto.classificacaoSecundaria.id === 39729 || projeto.classificacaoSecundaria.id === 44194 || projeto.classificacaoSecundaria.id === 44195 || projeto.classificacaoSecundaria.id === 39730) && relatorioExtensao.tipoRelatorioTecnicoItem === 3">

          <!-- Houve mudança nas datas de início e/ou de conclusão da ação de extensão? -->
          <v-flex xs12>
            <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.mudancaDatasAcao !== null"
              label="Houve mudança nas datas de início e/ou de conclusão da ação de extensão?"
              :value="this.relatorioExtensao.mudancaDatasAcao === 'S' ? 'Sim' : 'Não'"></c-readonly-field>
            <c-readonly-field class="textoRelatorio" v-else
              label="Houve mudança nas datas de início e/ou de conclusão da ação de extensão?"
              value="-"></c-readonly-field>
          </v-flex>

          <!-- Justificativa -->
          <v-flex xs12 v-if="this.relatorioExtensao.mudancaDatasAcao === 'S'">
            <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.justificativaMudancaDatasAcao !== null"
              label="Justificativa" :value="this.relatorioExtensao.justificativaMudancaDatasAcao"></c-readonly-field>
            <c-readonly-field class="textoRelatorio" v-else label="Justificativa" value="-"></c-readonly-field>
          </v-flex>

        </v-layout>

        <!-- Período a que se refere o relatório -->
        <v-layout row wrap text-xs-left>
          <v-flex xs12>
            <label class="textoRelatorio">Período a que se refere o relatório</label>
          </v-flex>
        </v-layout>

        <v-layout row text-xs-left>
          <v-flex md5 xs12>
            <c-readonly-field class="textoRelatorio" label="Início:"
              :value="relatorioExtensao.dtInicialFormatada"></c-readonly-field>
          </v-flex>
          <v-flex md1></v-flex>
          <v-flex md5 xs12>
            <c-readonly-field class="textoRelatorio" label="Fim:"
              :value="relatorioExtensao.dtFinalFormatada"></c-readonly-field>
          </v-flex>
          <v-flex md1></v-flex>
        </v-layout>

        <br>

        <!-- Situação do relatório -->
        <v-layout row wrap text-xs-left>
          <v-flex xs12>
            <c-readonly-field class="textoRelatorio" v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null"
              label="Situação do relatório"
              :value="getSituacaoRelatorio(relatorioExtensao.situacaoRelatorioTecnicoItem)"></c-readonly-field>
            <c-readonly-field class="textoRelatorio" v-else label="Situação do relatório" value="-"></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Quando o relatório técnico está aprovado ou reprovado -->
        <div
          v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null && (relatorioExtensao.situacaoRelatorioTecnicoItem === 3 || relatorioExtensao.situacaoRelatorioTecnicoItem === 4)">

          <!-- Relatório técnico aprovado -->
          <div
            v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null && relatorioExtensao.situacaoRelatorioTecnicoItem === 3">

            <br>

            <!-- Data de aprovação do relatório pela Câmara de Extensão -->
            <v-layout row wrap text-xs-left
              v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null && relatorioExtensao.situacaoRelatorioTecnicoItem === 3">
              <v-flex xs12>
                <c-readonly-field class="textoRelatorio" v-if="relatorioExtensao.dtAprovacaoRelatorio !== null"
                  label="Data de aprovação do relatório pela Câmara de Extensão"
                  :value="relatorioExtensao.dtAprovacaoFormatada"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else
                  label="Data de aprovação do relatório pela Câmara de Extensão" value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

          </div>

          <!-- Relatório técnico reprovado -->
          <div
            v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null && relatorioExtensao.situacaoRelatorioTecnicoItem === 4">

            <br>

            <!-- Data de reprovação do relatório pela Câmara de Extensão -->
            <v-layout row wrap text-xs-left
              v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null && relatorioExtensao.situacaoRelatorioTecnicoItem === 4">
              <v-flex xs12>
                <c-readonly-field class="textoRelatorio" v-if="relatorioExtensao.dtReprovacaoRelatorio !== null"
                  label="Data de reprovação do relatório pela Câmara de Extensão"
                  :value="relatorioExtensao.dtReprovacaoFormatada"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else
                  label="Data de reprovação do relatório pela Câmara de Extensão" value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

          </div>

          <br>

          <!-- Processo -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field class="textoRelatorio" v-if="relatorioExtensao.processo !== null" label="Processo"
                :value="relatorioExtensao.processo"></c-readonly-field>
              <c-readonly-field class="textoRelatorio" v-else label="Processo" value="-"></c-readonly-field>
            </v-flex>
          </v-layout>

        </div>

        <br>

        <v-divider></v-divider>

        <br>
        <br>

        <v-form v-model="formularioValido" ref="form">

          <!-- Tipo de relatório -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <div class="item">
                <c-readonly-field v-if="relatorioExtensao.tipoRelatorioTecnicoItem === 1" label="Tipo do relatório"
                  value="Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."></c-readonly-field>

                <c-readonly-field v-if="relatorioExtensao.tipoRelatorioTecnicoItem === 2" label="Tipo do relatório"
                  value="Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."></c-readonly-field>

                <c-readonly-field v-if="relatorioExtensao.tipoRelatorioTecnicoItem === 3" label="Tipo do relatório"
                  value="Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."></c-readonly-field>

                <c-readonly-field v-if="!relatorioExtensao.tipoRelatorioTecnicoItem" label="Tipo do relatório"
                  value="-"></c-readonly-field>
              </div>
            </v-flex>
          </v-layout>

          <br>
          <br>

          <!-- Nova data de conclusão da ação de extensão -->
          <!-- (caso o usuário selecione relatório com renovação) -->
          <div v-if="relatorioExtensao.tipoRelatorioTecnicoItem === 2">
            <v-layout row wrap text-xs-left>
              <v-flex xs12>
                <c-readonly-field class="item" label="Nova data de conclusão da ação de extensão:"
                  :value="relatorioExtensao.dtNovaConclusaoFormatada"></c-readonly-field>
                <br>
              </v-flex>
            </v-layout>
          </div>


          <!--
            Apresentar justificativa para envio do relatório fora do prazo.
          -->
          <v-layout row wrap text-xs-left v-if="relatorioForaPrazo === true">
            <v-flex xs12>
              <c-readonly-field label="Apresentar justificativa para envio do relatório fora do prazo:" class="item"
                align="justify" :value="relatorioExtensao.justificativaForaPrazo || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>

          <div v-if="relatorioForaPrazo === true">
            <br>
            <br>
          </div>

          <!--
            1) A metodologia foi alterada para alcançar os objetivos da proposta inicial?
          -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field label="1) A metodologia foi alterada para alcançar os objetivos da proposta inicial?"
                class="item" align="justify"
                :value="relatorioExtensao.opcao5 === null ? '-' : relatorioExtensao.opcao5 === 'S' ? 'Sim' : 'Não'">
              </c-readonly-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap text-xs-left v-if="relatorioExtensao.opcao5 === 'S'">
            <v-flex xs12>
              <c-readonly-field class="textoRelatorio" align="justify"
                label="Apresente sucintamente as alterações implementadas:"
                :value="relatorioExtensao.texto1 !== null && relatorioExtensao.texto1 !== '' ? relatorioExtensao.texto1 : '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>

          <br>
          <br>

          <!--
            2) Local de execução da ação.
          -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field label="2) Local de execução da ação:" class="item" align="justify"
                :value="relatorioExtensao.texto2 || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>

          <br>
          <br>

          <!--
            3) Informar o quantitativo total de indivíduos beneficiados no período deste relatório.
          -->
          <v-layout row wrap text-xs-left
            v-if="relatorioExtensao.texto3 != null && relatorioExtensao.texto3.length !== 0 && relatorioExtensao.situacaoRelatorioTecnicoItem !== 1">
            <v-flex xs12>
              <c-readonly-field
                label="3) Informar o quantitativo total de indivíduos beneficiados no período deste relatório"
                class="item" align="justify" :value="relatorioExtensao.texto3 || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap text-xs-left v-else>
            <v-flex xs12>
              <label class="item">3) Informar o quantitativo total de indivíduos beneficiados no período deste
                relatório</label>
              <br>
              <br>
              <!-- 3.1 - Público-alvo direto. -->
              <c-readonly-field class="textoRelatorio"
                label="3.1 - Público-alvo direto (público concretamente registrado):"
                :value="relatorioExtensao.publicoAlvoDireto || '-'">
              </c-readonly-field>
              <!-- 3.2 - Público-alvo indireto. -->
              <c-readonly-field class="textoRelatorio"
                label="3.2 - Público-alvo indireto (estimativa de público atingido indiretamente):"
                :value="relatorioExtensao.publicoAlvoIndireto || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>

          <br>
          <br>

          <!--
          4) Atividades e resultados.
          -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <label class="item">4) Atividades e resultados</label>
            </v-flex>
          </v-layout>

          <!-- Cards com as atividades -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <v-col v-for="(item, i) in relatorioExtensao.listaRelatorioAtividade" :key="i">
                <v-card outlined>
                  <v-card-text>

                    <!-- Nome e descrição sucinta da atividade -->
                    <v-layout row wrap text-xs-left>
                      <v-flex xs12>
                        <c-readonly-field class="textoRelatorio" align="justify"
                          label="Nome e descrição sucinta da atividade" :value="item.descricao">
                        </c-readonly-field>
                        <c-readonly-field v-if="item.detalhamento !== null && item.detalhamento !== ''"
                          class="textoRelatorio" align="justify" :value="item.detalhamento">
                        </c-readonly-field>
                      </v-flex>
                    </v-layout>

                    <!-- Principal objetivo específico ao qual esta atividade está vinculada -->
                    <v-layout row wrap text-xs-left>
                      <v-flex xs12>
                        <c-readonly-field class="textoRelatorio" align="justify"
                          label="Principal objetivo específico ao qual esta atividade está vinculada"
                          :value="item.objetivoEspecifico !== null && item.objetivoEspecifico !== '' ? item.objetivoEspecifico : '-'">
                        </c-readonly-field>
                      </v-flex>
                    </v-layout>

                    <!-- Situação -->
                    <v-layout row wrap text-xs-left>
                      <v-flex xs12>
                        <c-readonly-field v-if="item.situacaoAtividade !== null" class="textoRelatorio" label="Situação"
                          :value="situacaoAtividade.format(item.situacaoAtividade.item)">
                        </c-readonly-field>
                        <c-readonly-field v-if="item.situacaoAtividade === null" class="textoRelatorio" label="Situação"
                          value="-">
                        </c-readonly-field>
                      </v-flex>
                    </v-layout>

                    <!-- Datas de início efetivo e de conclusão efetiva -->
                    <v-layout row wrap text-xs-left>

                      <!-- Início efetivo -->
                      <v-flex md5 xs12>
                        <c-readonly-field class="textoRelatorio" label="Início efetivo"
                          :value="dates.format(item.dtInicioEfetivo)">
                        </c-readonly-field>
                      </v-flex>

                      <v-flex md1></v-flex>

                      <!-- Conclusão efetiva -->
                      <v-flex md5 xs12>
                        <c-readonly-field class="textoRelatorio" label="Conclusão efetiva"
                          :value="dates.format(item.dtFimEfetivo)">
                        </c-readonly-field>
                      </v-flex>

                      <v-flex md1></v-flex>

                    </v-layout>

                    <!-- Resultados -->
                    <v-layout row wrap text-xs-left>
                      <v-flex xs12>
                        <c-readonly-field class="textoRelatorio" align="justify" label="Resultados"
                          :value="item.resultados !== null && item.resultados !== '' ? item.resultados : '-'">
                        </c-readonly-field>
                      </v-flex>
                    </v-layout>

                  </v-card-text>
                </v-card>
              </v-col>
            </v-flex>
          </v-layout>

          <br>
          <br>

          <!--
            5) Discutir de forma geral a relevância das atividades, seu mérito extensionista, impacto, abrangência social, interdisciplinaridade e visibilidade.
          -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field
                label="5) Discutir de forma geral a relevância das atividades, seu mérito extensionista, impacto, abrangência social, interdisciplinaridade e visibilidade:"
                class="item" align="justify" :value="relatorioExtensao.texto4 || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>

          <br>
          <br>

          <!--
            6) Descrever de que maneira a ação de extensão contribuiu para a formação do aluno de graduação integrante da equipe.
          -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field
                label="6) Descrever de que maneira a ação de extensão contribuiu para a formação do aluno de graduação integrante da equipe:"
                class="item" align="justify" :value="relatorioExtensao.texto5 || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>

          <br>
          <br>

          <!--
            7) Relacionar os fatores que interferiram na execução da ação.
          -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <label class="item">7) Relacionar os fatores que interferiram na execução da ação</label>
            </v-flex>
          </v-layout>
          <br>
          <br>
          <!-- 7.1 - Positivos. -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field class="textoRelatorio" align="justify" label="7.1 - Positivos:"
                :value="relatorioExtensao.texto6 || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>
          <!-- 7.2 - Negativos. -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field class="textoRelatorio" align="justify" label="7.2 - Negativos:"
                :value="relatorioExtensao.texto7 || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>

          <br>
          <br>

          <!--
            8) Equipe.
          -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <label class="item">8) Equipe.</label>
            </v-flex>
          </v-layout>

          <!-- Tabela com os membros da equipe. -->
          <v-data-table :headers="headersIntegrantes" :items="relatorioExtensao.listaRelatorioParticipante"
            :items-per-page="-1" hide-default-footer :header-props="{ sortIcon: null }" class="tabelaEquipe">

            <!-- Formata o campo "Assessor". -->
            <template v-slot:item.assessor="props">{{ formatAssessor.format(props.item.assessor, props.item.funcao.item)
            }}</template>

            <!-- Formata o campo "Data inicial". -->
            <template v-slot:item.dataInicial="props">{{ dates.format(props.item.dataInicial) }}</template>

            <!-- Formata o campo "Data final". -->
            <template v-slot:item.dataFinal="props">{{ dates.format(props.item.dataFinal) }}</template>

          </v-data-table>

          <br>
          <br>

          <!--
            9) Formas de apoio.
          -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <label class="item">9) Formas de apoio</label>
            </v-flex>
          </v-layout>
          <br>
          <br>
          <!-- 9.1 - A ação de extensão recebeu apoio da ProEx? -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field class="textoRelatorio" label="9.1 - A ação de extensão recebeu apoio da ProEx?"
                :value="relatorioExtensao.opcao1 === null ? '-' : relatorioExtensao.opcao1 === 'S' ? 'Sim' : 'Não'">
              </c-readonly-field>
            </v-flex>
          </v-layout>
          <div v-if="relatorioExtensao.opcao1 === 'S'">
            <v-layout row wrap text-xs-left>
              <v-flex xs12>
                <label class="textoRelatorioSubitem">Especifique a(s) forma(s) de apoio:</label>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean1_1" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Bolsa</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean1_2" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Passagem</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean1_3" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Diária</div>
                  </template></v-checkbox></v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean1_4" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Material de consumo</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean1_5" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Material permanente</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean1_6" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Recurso financeiro</div>
                  </template></v-checkbox></v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean1_7" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Espaço físico</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean1_8" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Divulgação</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean1_9" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Transporte</div>
                  </template></v-checkbox></v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs11 sm4><v-checkbox v-model="relatorioExtensao.boolean1_10" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Outros</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs11 sm6>
                <c-readonly-field class="textoRelatorio" align="justify" label="Especifique:"
                  v-model="relatorioExtensao.texto14">
                </c-readonly-field>
              </v-flex>
            </v-layout>
          </div>

          <br>

          <!-- 9.2 - A ação de extensão recebeu apoio de outras instituições e/ou órgãos de fomento nacionais, internacionais ou estrangeiros? -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field class="textoRelatorio"
                label="9.2 - A ação de extensão recebeu apoio de outras instituições e/ou órgãos de fomento nacionais, internacionais ou estrangeiros?"
                :value="relatorioExtensao.opcao2 === null ? '-' : relatorioExtensao.opcao2 === 'S' ? 'Sim' : 'Não'">
              </c-readonly-field>
            </v-flex>
          </v-layout>
          <div v-if="relatorioExtensao.opcao2 === 'S'">
            <v-layout row wrap text-xs-left>
              <v-flex xs12>
                <label class="textoRelatorioSubitem">Especifique a(s) forma(s) de apoio:</label>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean2_1" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Bolsa</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean2_2" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Passagem</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean2_3" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Diária</div>
                  </template></v-checkbox></v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean2_4" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Material de consumo</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean2_5" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Material permanente</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean2_6" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Recurso financeiro</div>
                  </template></v-checkbox></v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean2_7" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Espaço físico</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean2_8" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Divulgação</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs4><v-checkbox v-model="relatorioExtensao.boolean2_9" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Transporte</div>
                  </template></v-checkbox></v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs11 sm4><v-checkbox v-model="relatorioExtensao.boolean2_10" readonly><template v-slot:label>
                    <div class="v-checkbox_label">Outros</div>
                  </template></v-checkbox></v-flex>
              <v-flex xs11 sm6>
                <c-readonly-field class="textoRelatorio" align="justify" label="Especifique:"
                  v-model="relatorioExtensao.texto15">
                </c-readonly-field>
              </v-flex>
            </v-layout>
          </div>

          <!-- 9.3 - Os recursos financeiros indicados no(s) item(ns) 9.1 e/ou 9.2 foram executados por: -->
          <div
            v-if="(relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 === true) || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 === true)">
            <br>
            <v-layout row wrap text-xs-left>
              <v-flex xs12>

                <!-- Recurso financeiro indicado apenas no item 9.1. -->
                <label class="textoRelatorio"
                  v-if="(relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 === true) && (relatorioExtensao.opcao2 === 'N' || relatorioExtensao.boolean2_6 === false)">
                  9.3 - Os recursos financeiros indicados no item 9.1 foram executados por:
                </label>

                <!-- Recurso financeiro indicado apenas no item 9.2. -->
                <label class="textoRelatorio"
                  v-if="(relatorioExtensao.opcao1 === 'N' || relatorioExtensao.boolean1_6 === false) && (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 === true)">
                  9.3 - Os recursos financeiros indicados no item 9.2 foram executados por:
                </label>

                <!-- Recurso financeiro indicado nos itens 9.1 e 9.2. -->
                <label class="textoRelatorio"
                  v-if="(relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 === true) && (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 === true)">
                  9.3 - Os recursos financeiros indicados nos itens 9.1 e 9.2 foram executados por:
                </label>

              </v-flex>
            </v-layout>
            <br>

            <!-- UFES e CNPq -->
            <v-layout row>

              <!-- UFES -->
              <v-flex xs6 sm2>
                <v-checkbox v-model="relatorioExtensao.boolean3_1" readonly>
                  <template v-slot:label>
                    <div class="v-checkbox_label">UFES</div>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs6 sm2>
                <v-text-field-money v-model="relatorioExtensao.valor3_1" label="Valor (R$):" v-bind:properties="{
                  readonly: true,
                  placeholder: ' ',
                }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
              </v-flex>

              <v-flex xs0 sm2></v-flex>

              <!-- CNPq -->
              <v-flex xs6 sm2>
                <v-checkbox v-model="relatorioExtensao.boolean3_2" readonly>
                  <template v-slot:label>
                    <div class="v-checkbox_label">CNPq</div>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs6 sm2>
                <v-text-field-money v-model="relatorioExtensao.valor3_2" label="Valor (R$):" v-bind:properties="{
                  readonly: true,
                  placeholder: ' ',
                }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
              </v-flex>
            </v-layout>

            <!-- CAPES e FAPES -->
            <v-layout row>

              <!-- CAPES -->
              <v-flex xs6 sm2>
                <v-checkbox v-model="relatorioExtensao.boolean3_3" readonly>
                  <template v-slot:label>
                    <div class="v-checkbox_label">CAPES</div>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs6 sm2>
                <v-text-field-money v-model="relatorioExtensao.valor3_3" label="Valor (R$):" v-bind:properties="{
                  readonly: true,
                  placeholder: ' ',
                }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
              </v-flex>

              <v-flex xs0 sm2></v-flex>

              <!-- FAPES -->
              <v-flex xs6 sm2>
                <v-checkbox v-model="relatorioExtensao.boolean3_4" readonly>
                  <template v-slot:label>
                    <div class="v-checkbox_label">FAPES</div>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs6 sm2>
                <v-text-field-money v-model="relatorioExtensao.valor3_4" label="Valor (R$):" v-bind:properties="{
                  readonly: true,
                  placeholder: ' ',
                }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
              </v-flex>
            </v-layout>

            <!-- FEST E FUCAM -->
            <v-layout row>

              <!-- FEST -->
              <v-flex xs6 sm2>
                <v-checkbox v-model="relatorioExtensao.boolean3_5" readonly>
                  <template v-slot:label>
                    <div class="v-checkbox_label">FEST</div>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs6 sm2>
                <v-text-field-money v-model="relatorioExtensao.valor3_5" label="Valor (R$):" v-bind:properties="{
                  readonly: true,
                  placeholder: ' ',
                }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
              </v-flex>

              <v-flex xs0 sm2></v-flex>

              <!-- FUCAM -->
              <v-flex xs6 sm2>
                <v-checkbox v-model="relatorioExtensao.boolean3_6" readonly>
                  <template v-slot:label>
                    <div class="v-checkbox_label">FUCAM</div>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs6 sm2>
                <v-text-field-money v-model="relatorioExtensao.valor3_6" label="Valor (R$):" v-bind:properties="{
                  readonly: true,
                  placeholder: ' ',
                }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
              </v-flex>
            </v-layout>

            <!-- Outros -->
            <v-layout row>
              <v-flex xs6 sm2>
                <v-checkbox v-model="relatorioExtensao.boolean3_7" readonly>
                  <template v-slot:label>
                    <div class="v-checkbox_label">Outros</div>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs6 sm5>
                <c-readonly-field class="textoRelatorio" align="justify" label="Especifique:"
                  v-model="relatorioExtensao.texto16">
                </c-readonly-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs6 sm2>
                <v-text-field-money v-model="relatorioExtensao.valor3_7" label="Valor (R$):" v-bind:properties="{
                  readonly: true,
                  placeholder: ' ',
                }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
              </v-flex>
              <v-flex xs6 sm2></v-flex>
            </v-layout>

          </div>

          <br>
          <br>
          <br>

          <!--
            10) Houve cobrança de taxa de inscrição, participação, visitação ou similar?
          -->
          <v-layout row wrap justify-center>
            <v-flex xs12 row wrap text-xs-left>
              <c-readonly-field label="10) Houve cobrança de taxa de inscrição, participação, visitação ou similar?"
                class="item"
                :value="relatorioExtensao.opcao4 === null ? '-' : relatorioExtensao.opcao4 === 'S' ? 'Sim' : 'Não'">
              </c-readonly-field>
            </v-flex>
          </v-layout>
          <div v-if="relatorioExtensao.opcao4 === 'S'">
            <br>
            <v-layout row wrap text-xs-left>
              <v-flex xs12>
                <label class="textoRelatorio">Os recursos financeiros foram administrados por:</label>
              </v-flex>
            </v-layout>
            <br>

            <!-- UFES -->
            <v-layout>
              <v-flex xs11 sm2>
                <v-checkbox v-model="relatorioExtensao.boolean4_1" readonly>
                  <template v-slot:label>
                    <div class="v-checkbox_label">UFES</div>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs11 sm2>
                <v-text-field-money v-model="relatorioExtensao.valor4_1" label="Valor (R$):" v-bind:properties="{
                  readonly: true,
                  placeholder: ' ',
                }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
              </v-flex>
            </v-layout>

            <!-- FEST -->
            <v-layout>
              <v-flex xs11 sm2>
                <v-checkbox v-model="relatorioExtensao.boolean4_2" readonly>
                  <template v-slot:label>
                    <div class="v-checkbox_label">FEST</div>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs11 sm2>
                <v-text-field-money v-model="relatorioExtensao.valor4_2" label="Valor (R$):" v-bind:properties="{
                  readonly: true,
                  placeholder: ' ',
                }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
              </v-flex>
            </v-layout>

            <!-- FUCAM -->
            <v-layout>
              <v-flex xs11 sm2>
                <v-checkbox v-model="relatorioExtensao.boolean4_3" readonly>
                  <template v-slot:label>
                    <div class="v-checkbox_label">FUCAM</div>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs11 sm2>
                <v-text-field-money v-model="relatorioExtensao.valor4_3" label="Valor (R$):" v-bind:properties="{
                  readonly: true,
                  placeholder: ' ',
                }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
              </v-flex>
            </v-layout>

            <!-- Outros -->
            <v-layout>
              <v-flex xs11 sm2>
                <v-checkbox v-model="relatorioExtensao.boolean4_4" readonly>
                  <template v-slot:label>
                    <div class="v-checkbox_label">Outros</div>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs11 sm5>
                <c-readonly-field class="textoRelatorio" align="justify" label="Especifique:"
                  v-model="relatorioExtensao.texto17">
                </c-readonly-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs11 sm2>
                <v-text-field-money v-model="relatorioExtensao.valor4_4" label="Valor (R$):" v-bind:properties="{
                  readonly: true,
                  placeholder: ' ',
                }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
              </v-flex>
              <v-flex xs6 sm2></v-flex>
            </v-layout>

          </div>

          <br>
          <br>
          <br>

          <!--
            11) Informar as parcerias/colaborações: contatos nacionais e internacionais efetivamente ocorridos em função da atividade, como convênios, acordos de colaboração e outros.
          -->
          <v-layout row wrap justify-center>
            <v-flex xs12>
              <label class="item">11) Informar as parcerias/colaborações: contatos nacionais e internacionais efetivamente
                ocorridos em função da atividade, como convênios, acordos de colaboração e outros.</label>
            </v-flex>
          </v-layout>

          <!-- Tabela com as parcerias associadas ao relatório -->
          <v-data-table v-if="relatorioExtensao.listaRelatorioParceria.length !== 0" :headers="headersParcerias"
            :header-props="{ sortIcon: null }" :items="relatorioExtensao.listaRelatorioParceria" :items-per-page="-1"
            hide-default-footer class="tabela">
          </v-data-table>

          <!-- Caso nenhuma parceria/colaboração tenha sido informada, exibe mensagem ao usuário -->
          <v-layout row wrap justify-center v-if="relatorioExtensao.listaRelatorioParceria.length === 0">
            <v-flex xs12>
              <v-alert class="alerta" color="#00796b" outlined>
                Nenhuma parceria/colaboração foi informada
              </v-alert>
            </v-flex>
          </v-layout>

          <br>
          <br>

          <!--
            12) Informar produtos de extensão.
          -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <label class="item">12) Informar produtos de extensão</label>
            </v-flex>
          </v-layout>
          <br>
          <br>
          <!-- 12.1 - Trabalhos publicados e/ou aceitos para publicação no período, tais como livros, capítulos de livros, artigos em periódicos nacionais e internacionais, resumos em congressos, reuniões científicas e semelhantes. Indicar claramente entre os autores dos trabalhos, quando for o caso, os bolsistas e os voluntários. -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field class="textoRelatorio" align="justify"
                label="12.1 - Trabalhos publicados e/ou aceitos para publicação no período, tais como livros, capítulos de livros, artigos em periódicos nacionais e internacionais, resumos em congressos, reuniões científicas e semelhantes. Indicar claramente entre os autores dos trabalhos, quando for o caso, os bolsistas e os voluntários:"
                :value="relatorioExtensao.texto9 || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>
          <!-- 12.2 - Patente ou registro de invenção ou técnica (informar o título, se a patente é nacional, internacional ou “joint ventures” e outros dados que julgar adequados). -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field class="textoRelatorio" align="justify"
                label="12.2 - Patente ou registro de invenção ou técnica (informar o título, se a patente é nacional, internacional ou “joint ventures” e outros dados que julgar adequados):"
                :value="relatorioExtensao.texto10 || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>
          <!-- 12.3 - Outras atividades extensionistas, científicas ou administrativas que julgar pertinentes no período: organização ou participação em eventos científicos, consultorias, assessorias a órgãos de fomento, etc. -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field class="textoRelatorio" align="justify"
                label="12.3 - Outras atividades extensionistas, científicas ou administrativas que julgar pertinentes no período: organização ou participação em eventos científicos, consultorias, assessorias a órgãos de fomento, etc:"
                :value="relatorioExtensao.texto11 || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>
          <!-- 12.4 - Premiações obtidas em função do desenvolvimento da atividade de extensão (título do prêmio, quem outorgou, data, local); honrarias acadêmicas. -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field class="textoRelatorio" align="justify"
                label="12.4 - Premiações obtidas em função do desenvolvimento da atividade de extensão (título do prêmio, quem outorgou, data, local); honrarias acadêmicas:"
                :value="relatorioExtensao.texto12 || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>
          <!-- 12.5 - Links para matérias jornalísticas sobre a ação. -->
          <v-layout row wrap text-xs-left>
            <v-flex xs12>
              <c-readonly-field class="textoRelatorio" align="justify"
                label="12.5 - Links para matérias jornalísticas sobre a ação:" :value="relatorioExtensao.texto13 || '-'">
              </c-readonly-field>
            </v-flex>
          </v-layout>

          <br>
          <br>

          <!--
            13) Anexar materiais que comprovem a execução da ação de extensão, como: fotografias, livros, cartazes, panfletos, folders, manuais e outros.
          -->
          <v-layout row wrap justify-center>
            <v-flex xs12>
              <label class="item">13) Anexar materiais que comprovem a execução da ação de extensão, como: fotografias,
                livros, cartazes, panfletos, folders, manuais e outros:</label>
            </v-flex>
          </v-layout>

          <v-data-table v-if="relatorioExtensao.listaRelatorioArquivo.length !== 0" :headers="headers0"
            :header-props="{ sortIcon: null }" :items="relatorioExtensao.listaRelatorioArquivo" :items-per-page="-1"
            hide-default-footer class="tabela">
            <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
              Total de {{ relatorioExtensao.listaRelatorioArquivo.length }} arquivos
            </template>
          </v-data-table>

          <!-- Caso nenhum material tenha sido anexado ao relatório, exibe mensagem ao usuário -->
          <v-layout row wrap justify-center v-if="relatorioExtensao.listaRelatorioArquivo.length === 0">
            <v-flex xs12>
              <v-alert class="alerta" color="#00796b" outlined>
                Nenhum material foi anexado
              </v-alert>
            </v-flex>
          </v-layout>

          <br>
          <br>

        </v-form>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DataMenu from '@/components/c-date-menu'
import ReadonlyField from '@/components/c-readonly-field'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import formatAssessor from '@/utils/assessor'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import situacaoAtividade from '@/utils/situacaoAtividade'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['idProjeto', 'idRelatorioExtensao'],
  data: () => ({
    api_url: process.env.API_BASE_URL,
    dates: dates,
    formatAssessor: formatAssessor,
    situacaoAtividade: situacaoAtividade,
    listaTipoRelatorio: [{ descricao: 'Parcial' }, { descricao: 'Final' }],
    listaTipoRelatorio2: [{ descricao: 'Final' }],
    projeto: {
      classificacoesPrimariaSecundaria: [{}, {}]
    },
    relatorioForaPrazo: false,
    extensao: {},
    contatos: {},
    dadosCoordenador: {},
    relatorioExtensao: {},
    formularioValido: false,
    headersIntegrantes: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Função', align: 'left', value: 'funcao.descricao' },
      { text: 'Vínculo', align: 'left', value: 'vinculo' },
      { text: 'CH semanal', align: 'left', value: 'cargaHoraria' },
      { text: 'Data inicial', align: 'left', value: 'dataInicial' },
      { text: 'Data final', align: 'left', value: 'dataFinal' }
    ],
    headersParcerias: [
      { text: 'Nome do parceiro institucional/colaborador', align: 'left', value: 'nome' },
      { text: 'Descrição da parceria/colaboração', align: 'left', value: 'detalhamento' }
    ],
    headers0: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Tipo', align: 'left', value: 'tipoArquivo.descricao' },
      { text: 'Observação', left: 'left', value: 'observacao' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    // Retorna a situação do relatório.
    getSituacaoRelatorio: function (situacaoRelatorioTecnicoItem) {
      if (situacaoRelatorioTecnicoItem === 1) {
        return 'Em elaboração'
      } else if (situacaoRelatorioTecnicoItem === 2) {
        return 'Aguardando aprovação'
      } else if (situacaoRelatorioTecnicoItem === 3) {
        return 'Aprovado'
      } else if (situacaoRelatorioTecnicoItem === 4) {
        return 'Reprovado'
      } else {
        return 'Situação inválida'
      }
    }
  },
  mounted: function () {
    // Carrega a ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
    projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })

    // Carrega o relatório.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' })
    projetos.getRelatorioExtensao(this.idProjeto, this.idRelatorioExtensao)
      .then(response => {
        this.relatorioExtensao = response.data
        this.relatorioExtensao.dtInicialFormatada = dates.format(this.relatorioExtensao.dtInicial)
        this.relatorioExtensao.dtFinalFormatada = dates.format(this.relatorioExtensao.dtFinal)
        this.relatorioExtensao.dtNovaConclusaoFormatada = dates.format(this.relatorioExtensao.dtNovaConclusao)
        this.relatorioExtensao.dtAprovacaoFormatada = dates.format(this.relatorioExtensao.dtAprovacaoRelatorio)
        this.relatorioExtensao.dtReprovacaoFormatada = dates.format(this.relatorioExtensao.dtReprovacaoRelatorio)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' })
      })

    // Endpoint que retorna se o relatório está fora do prazo para envio.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' })
    projetos.getRelatorioTecnicoForaPrazo(this.idProjeto, this.idRelatorioExtensao)
      .then(response => {
        this.relatorioForaPrazo = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' })
      })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-date-menu': DataMenu,
    'c-readonly-field': ReadonlyField
  }
}
</script>

<style lang="css" scoped>
.v-text-field>>>label {
  font-size: 14pt;
}

.v-radio>>>label {
  font-size: 10.5pt;
}

.alerta {
  margin: 1.6em 0 2.0em 0;
  font-size: 1.10em;
  text-align: center;
}
</style>

<style lang="css">
#v-radio-group_label {
  font-size: 10.5pt;
}

.v-checkbox_label {
  font-size: 0.95em;
}

th.objetivoEspecifico,
th.resultados {
  width: 50%
}

.item {
  font-weight: bold;
  font-size: 1.25em;
}

.textoRelatorio {
  font-size: 1.2em;
}

.textoRelatorioSubitem {
  font-size: 1.15em;
}

.tabela {
  margin-top: 15px;
  margin-bottom: 20px;
}

.tabela th {
  font-weight: bold !important;
  font-size: 1.1em !important;
}

.tabela td {
  font-size: 1.1em !important;
}

.tabelaEquipe {
  margin-top: 15px;
  margin-bottom: 20px;
}

.tabelaEquipe th {
  font-weight: bold !important;
  font-size: 1.1em !important;
}

.tabelaEquipe td {
  font-size: 0.9em !important;
}

@media print {

  @page {
    size: auto;
    margin: 3.5em 0 3.5em 0;
  }

  .btnGerarPDF {
    visibility: hidden;
  }

}
</style>



// WEBPACK FOOTER //
// relatorio-tecnico-pdf.vue?5aab09f7